import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { ContentBox, PhoneInput, FormButtons, FormError, PortalForm } from '@portal/kit/pkg/components'

const RequestPhoneNumberView = props =>
  <ContentBox title={props.t('account.edit_my_phone_number')}>
    <PortalForm onSubmit={props.handleSubmit}>
      {props.submitError && <FormError message={props.submitError} />}
      <PhoneInput name="phone_number" label={props.t('account.phone_number.title')} />
      <FormButtons cancel="/my-account" submit isDisabled={props.hasValidationErrors} />
    </PortalForm>
  </ContentBox>

RequestPhoneNumberView.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitError: PropTypes.string,
}

export default withTranslation()(RequestPhoneNumberView)
